import React, { useCallback } from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Logo } from '../../../Form';

interface IHelpVideoTileProps {
  href: string;
  title: string;
}

const StyledBox = styled(Box)(() => ({
  display: 'inline-block',
  textAlign: 'center',
  background: '#44bdb5',
  borderRadius: '6px',
  width: '100%',
  position: 'relative',
  overflow: 'hidden',
  marginBottom: '10px',
  border: '1px solid #ddd',
  cursor: 'pointer',
  transition: 'opacity 0.3s ease',
  '&:hover': {
    opacity: 0.95,
  },
  '&:active': {
    opacity: 0.9,
  },
}));

const StyledTitle = styled(Typography)(() => ({
  background: 'white',
  padding: '15px',
  fontSize: '1.1em',
  color: '#333',
}));

const StyledText = styled(Typography)(() => ({
  height: '60px',
  color: 'white!important',
  lineHeight: '80px',
  marginTop: '-65px',
  fontSize: '1.2em',
}));

export default function HelpVideoTile({ href, title }: IHelpVideoTileProps) {
  const handleClick = useCallback(() => {
    window.open(href, '_blank');
  }, [href]);

  return (
    <StyledBox onClick={handleClick}>
      <Logo />
      <StyledText>Tech Check Articles</StyledText>
      <StyledTitle>{title}</StyledTitle>
    </StyledBox>
  );
}
